<template>
  <transition name="side-navigator">
    <div v-if="showSideNavigator" class="comic-side-navigator-container">
      <div :class="['nav-top', !isShowNav ? 'nav-top-show' : '']" @click="handleShowNav">
        {{ isShowNav ? '收起' : '展开' }}
      </div>
      <!-- <div class="nav-item ticket"></div> -->
      <div
        v-for="(item, index) in navLists.filter(i => i.value !== 'Share')"
        :key="item.value"
        class="nav-item"
        :class="{ active: activeItem === item.value }"
        @click="scrollTo(item.value)"
        v-rseat="`click_carnival_side_${item.value}`"
        v-show="isShowNav"
      >
        <div class="nav-item-text">{{ item.label }}</div>
        <div v-if="index !== navLists.length - 1" class="bottom-line" />
      </div>
      <div class="nav-bottom" @click="scrollToTop()">返回顶部</div>
    </div>
  </transition>
</template>
<script>
import _ from 'lodash'

const DELTA = 50
const DELTA_SHOW_NAV = 89

export default {
  props: {
    navLists: {
      type: Array,
      default: () => [],
    },
    currentCity: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeItem: '',
      showSideNavigator: false,
      isShowNav: true,
    }
  },
  methods: {
    onScroll() {
      // 兼容ie forEach
      if (typeof NodeList.prototype.forEach !== 'function') {
        NodeList.prototype.forEach = Array.prototype.forEach
      }
      const navContents = document.querySelectorAll('[data-anchor]')
      const cityTab = document.querySelector('[data-city-tab]')
      const cityTabHeight = cityTab ? cityTab.offsetHeight : DELTA
      // window 宽度小于 1366 页面缩放75%
      const windowWidth = window.innerWidth
      const offsetTops = []
      navContents.forEach(item => {
        const scrollHei = item.offsetTop - cityTabHeight - 1
        const offset = windowWidth > 1366 ? scrollHei : scrollHei * 0.75
        offsetTops.push({
          offset,
          label: item.getAttribute('data-anchor'),
        })
      })
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let active = ''
      offsetTops.forEach(item => {
        if (scrollTop >= item.offset) {
          active = item.label
        }
      })
      if (scrollTop > DELTA_SHOW_NAV) {
        this.showSideNavigator = true
      } else {
        this.showSideNavigator = false
      }
      this.activeItem = active
    },
    scrollTo(active) {
      const cityTab = document.querySelector('[data-city-tab]')
      const cityTabHeight = cityTab ? cityTab.offsetHeight : DELTA
      const navContent = document.querySelectorAll(`[data-anchor="${active}"]`)[0]
      // window 宽度小于 1366 页面缩放75%
      const windowWidth = window.innerWidth
      const scrollHei = navContent.offsetTop - cityTabHeight
      const top = windowWidth > 1366 ? scrollHei : scrollHei * 0.75
      if (navContent) {
        window.scrollTo({
          top,
          behavior: 'smooth',
        })
      }
    },
    scrollToTop() {
      document.body.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    },
    handleShowNav() {
      this.isShowNav = !this.isShowNav
    },
  },
  mounted() {
    window.addEventListener('scroll', _.throttle(this.onScroll, 100), false)
  },
  destroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
}
</script>
<style lang="less" scoped>
.comic-side-navigator-container {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  .nav-top,
  .nav-bottom {
    position: relative;
    left: 10px;
    width: 116px;
    height: 58px;
    font-size: 20px;
    color: #fff;
    line-height: 22px;
    padding: 17px 0 20px 17px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .nav-top {
    background: rgba(0, 0, 0, 0.77);
    background: linear-gradient(130deg, transparent 16px, rgba(0, 0, 0, 0.77) 0);
    &::before {
      display: inline-block;
      content: '';
      border-width: 0 10px 16px;
      border-style: solid;
      border-color: transparent transparent #ceff1a;
      margin-right: 6px;
    }
    &.nav-top-show {
      border-bottom: 2px solid #000;
      &::before {
        border-width: 16px 10px 0;
        border-color: #ceff1a transparent transparent;
      }
    }
  }
  .nav-bottom {
    background: transparent url('~@/assets/carnival2020/side-navigator/navigator-bottom@2x.png') center center no-repeat;
    background-size: cover;
  }
  .nav-item {
    position: relative;
    left: 10px;
    width: 116px;
    cursor: pointer;
    .nav-item-text {
      width: 100%;
      height: 60px;
      font-size: 26px;
      color: #9972ff;
      line-height: 26px;
      padding: 18px 0 16px 20px;
      box-sizing: border-box;
      background-color: #000;
    }
    .bottom-line {
      width: 100%;
      height: 2px;
      background-color: rgba(0, 0, 0, 0.77);
    }
    &.active .nav-item-text {
      color: #ceff1a;
    }
  }
  .ticket {
    width: 126px;
    height: 70px;
    background: transparent url('~@/assets/carnival2020/side-navigator/navigator-ticket@2x.png') center center no-repeat;
    background-size: cover;
    left: 0;
  }
}
.side-navigator-enter,
.side-navigator-leave-to {
  opacity: 0;
  transform: translateY(-45%);
}
.side-navigator-enter-to,
.side-navigator-leave {
  opacity: 1;
  transform: translateY(-50%);
}
.side-navigator-enter-active,
.side-navigator-leave-active {
  transition: all 0.5s ease-in-out;
}
</style>
